function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutotrader = function SvgAutotrader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 89.4 59.6"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M75.4 34.8 70 48.3c-2.8 6.5-8.9 11.2-16.1 11.3H0l10-24.7c0-.1 65.4-.1 65.4-.1",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#222b5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4 0H35.6c-7.2.1-13.3 4.7-16.1 11.3l-5.4 13.5h65.4C79.4 24.7 89.4 0 89.4 0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#b11212"
    }
  }));
};
export default SvgAutotrader;